import styled from 'styled-components'
import { space } from 'styled-system'
import SALink from 'components/SALink'
export const GenericFlexWrapper = styled.div`
  ${space};
  display: flex;
  justify-content: space-between;
  ${(props) => props.centerBoth && 'justify-content: center; align-items: center;'}
  gap: 16px;
`
export const Wrapper = styled.div`
  padding: 0 92px;
  max-width: 1500px;
  margin: 0 auto;

  h1 {
    margin-top: 56px;
  }

  [data-type='sub-text'] {
    margin-bottom: 20px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    padding: 0 16px;
  }
`
export const Blurb = styled.div`
  margin-bottom: 25px;

  div {
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      display: none;
    }
  }
`
export const Header = styled.h1`
  font-weight: 200;
  font-size: 46px;
`
export const ArtistArtworkWrapper = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.footerBackground};
`
export const ArtistArtworkItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
  gap: 24px;

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    justify-content: center;
    flex-wrap: wrap;
    width: 288px;
    margin: 0 auto;
  }
`
export const ArtistSection = styled(GenericFlexWrapper)`
  max-width: 462px;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    flex-direction: column;
    text-align: center;
    margin-bottom: 24px;
  }
`
export const Avatar = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-right: 24px;
  border-color: 1px solid #000;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    margin: 0 0 16px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    justify-content: center;
    flex-wrap: wrap;
  }
`
export const ArtistInfoSection = styled.div`
  width: 250px;

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    width: 290px;
  }
`
export const FollowButton = styled(SALink)`
  ${space};
  gap: 8px;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => (props.following ? '#dddddd' : props.theme.colors.default)};
  text-decoration: none;
  width: 140px;
  height: 50px;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 20px;
  * {
    display: inline-block;
  }
  div {
    margin-top: 2px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    margin-right: 0;
    width: 141px;
  }
`
export const ArtistName = styled.div`
  font-size: 28px;

  a {
    text-decoration: none;
    color: #1E1E1E;
  }
`
export const ArtistCountry = styled.div`
  margin-top: 5px;
`
export const ViewArtworks = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 0px 16px;
  border: 1px solid ${(props) => props.theme.colors.default};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  [data-type='view-artworks'] {
    text-wrap: nowrap;
  }
  a {
    color: ${(props) => props.theme.colors.default};
    text-decoration: none;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    width: 140px;
  }
`
export const ArtworkWrapper = styled.div`
  display: flex;
  width: 620px;
  justify-content: space-between;

  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    width: 305px;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`
export const Artwork = styled.img`
  ${space};
  width: 150px;
  height: 150px;

  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    width: 140px;
    height: 140px;
  }
`